/**
 * CompCheckBridgeService is a service class that interacts with a bridge to perform component checks.
 * It can either use a real bridge or a mock bridge for testing purposes.
 */
class CompCheckBridgeService {
    /**
     * Constructs the CompCheckBridgeService instance.
     * @param {Object} $injector - The injector service for dependency injection.
     * @param {Object} $signals - The signals service for emitting events.
     * @param {Function} $timeout - The timeout service for delaying execution.
     */
    constructor($injector, $signals, $timeout) {
        this.$injector = $injector;
        this.$signals = $signals;
        this.$timeout = $timeout;

        /**
         * Services
         */
        this.LogBridgeService = $injector.get('LogBridgeService');

        /**
         * Mock bridge object with methods to simulate bridge behavior.
         */
        this.mockBridge = {
            /**
             * Returns a sorted list of post-launch tests.
             * @returns {Array} - Sorted list of test names.
             */
            getPostLaunchTests: function () {
                return _.sortBy(['SysMem', 'InternetConnection', 'ScreenRes', 'DiskSpace', 'WriteResponse', 'SysMem2', 'ScreenRes2', 'DiskSpace2', 'WriteResponse2', 'SysMem3', 'ScreenRes3', 'DiskSpace3', 'WriteResponse3', 'VmDetection']);
            },

            /**
             * Simulates running a test and emits the result after a delay.
             * @param {string} testName - The name of the test to run.
             */
            runTest: function (testName) {
                var r = Math.random(),
                    res = 'PASSED',
                    failMessage = null;

                if (testName !== 'VmDetection') {
                    if (r > 0.9) {
                        res = 'WARNING';
                    } else if (r > 0.6) {
                        res = 'FAILED';
                    }
                }
                $timeout(() => {
                    $signals.emit("runtimeTestResult", testName, res, failMessage);
                }, 100);
            }
        };

        // meta setup
        this._logIdentifier = 'CompCheckBridgeService';
        this.$logger = this.LogBridgeService;

        this.$logger.info(this, 'initialize');
    }

    /**
     * Checks if the bridge is available.
     * @returns {boolean} - True if the bridge is available, false otherwise.
     */
    isBridgeAvailable() {
        return window.jsBridgeCompCheck !== undefined;
    }

    /**
     * Gets the bridge context, either the real bridge or the mock bridge.
     * @returns {Object} - The bridge context.
     */
    getBridgeContext() {
        return window.jsBridgeCompCheck || this.mockBridge;
    }

    /**
     * Gets a sorted list of post-launch tests from the bridge context.
     * @returns {Array} - Sorted list of test names.
     */
    getPostLaunchTests() {
        return this.getBridgeContext().getPostLaunchTests();
    }

    /**
     * Runs a test using the bridge context.
     * @param {string} testName - The name of the test to run.
     */
    runTest(testName) {
        return this.getBridgeContext().runTest(testName);
    }
}

export default CompCheckBridgeService;